export default __webpack_public_path__ + "static/media/ic_portrait_48px.8ec8b12f.svg";